import { useAdminSettingsBatch, ADMIN_SETTINGS_BATCH_KEY } from "@/hooks/useAdminSettingsBatch";

export const STAGING_MODE_QUERY_KEY = ADMIN_SETTINGS_BATCH_KEY;

/**
 * Global Staging Mode flag (admin_settings.staging_mode). Readable by anon so
 * the badge also renders on marketing/public routes.
 */
export function useStagingMode() {
  const { data: isStaging = false, isLoading } = useAdminSettingsBatch<boolean>(
    (map) => map.staging_mode === "true",
  );
  return { isStaging, isLoading };
}
